import { action, observable } from 'mobx';
import { useRootStore } from './index';
import { AdFormatEnum } from 'api';
import { Optional } from 'utils/Optional';

interface State {
  articleGroupId: string;
  campaignId: Optional<string>;
  adFormat: Optional<Optional<AdFormatEnum>>;
  previews: string[];
}

export class CreativeTemplatePreviews {
  @observable state: Optional<State> = null;

  @action initialize(state: State): void {
    this.state = state;
  }

  @action clear(): void {
    this.state = null;
  }
}

export const useCreativeTemplatePreviews = (): CreativeTemplatePreviews => {
  const store = useRootStore();
  if (!store.creativeTemplatePreviews) throw new Error('CreativeTemplatePreviews has not been initialized');
  return store.creativeTemplatePreviews;
};
